import {createApp} from 'vue'
import Store from 'store'
import ProductDetailImages from './ProductDetailImages'

const component = createApp(ProductDetailImages).use(Store)

const el = '.nlx-component--product-detail-images'
const DOM = document.querySelector(el)


const scrapeImageData = (DOM) => {
    const data = []
    const imageArray = Array.from(DOM.querySelectorAll('.nlx-product-detail-images__thumbnail-container picture'))
    const escapeWhiteSpaceInUrl = (url) => url.replace(/\s/g, '%20')

    imageArray.forEach((item, index) => {
        data.push(
            {
                primaryUrl : escapeWhiteSpaceInUrl(item.querySelector('img').getAttribute('src')),
                srcsetUrlSmall : item.querySelector('.nlx-js-srcset-identifier-2'),
                ssrcsetUrlMedium : item.querySelector('.nlx-js-srcset-identifier-1'),
                alt : item.querySelector('img').getAttribute('alt'),
                isSelected : !!(index === 0)
            }
        )
    })

    Store.commit('productDetails/set_product_detail_image_data', data)
}

if(DOM){

    scrapeImageData(DOM) 

    component.mount(el)
}

